import type { BufferPort, GraphPort, Section } from './types';
export const CROSSFADE_SECONDS = .005;
export interface LoopBank { buffer: BufferPort; periodFrames: number; fadeFrames: number; startFrame: number; endFrame: number }
export function validateSection(section: Section, duration: number): void {
  if (!Number.isFinite(section.start) || !Number.isFinite(section.end) || section.start < 0 || section.end > duration || section.end - section.start < .05) throw new Error('Loop must be at least 50ms and lie within the song.');
}
export function buildLoopBank(graph: Pick<GraphPort, 'createBuffer'>, source: BufferPort, section: Section): LoopBank {
  validateSection(section, source.duration);
  const start = Math.round(section.start * source.sampleRate), end = Math.round(section.end * source.sampleRate);
  const period = end - start, fade = Math.max(1, Math.round(CROSSFADE_SECONDS * source.sampleRate));
  const buffer = graph.createBuffer(source.numberOfChannels, period * 2, source.sampleRate);
  for (let ch = 0; ch < source.numberOfChannels; ch++) {
    const src = source.getChannelData(ch), dst = buffer.getChannelData(ch);
    // At each exact section boundary, A's 5ms tail fades into B's 5ms head.
    // Both loop a two-period bank with a silent second half. PCM is shared by A/B.
    // This preserves the full beat period; overlapping sources do not shorten it.
    for (let i = 0; i < period; i++) dst[i] = src[start + i] * Math.min(1, i / fade);
    for (let i = 0; i < fade; i++) dst[period + i] = src[Math.min(end + i, source.length - 1)] * (1 - i / fade);
  }
  return { buffer, periodFrames: period, fadeFrames: fade, startFrame: start, endFrame: end };
}
